import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcarrentalserviceinpune() {



  const cardData =
  {
    keyword: ' Wedding Car Rental Services in Pune ',
    heading: 'Pune Corporate Cars India Private Limited: Wedding Car Rental Services in Pune ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides premium Wedding Car Rental Services in Pune, offering stylish, comfortable, and reliable transportation for weddings, receptions, engagement ceremonies, and family functions. Our fleet includes luxury sedans, SUVs, vintage cars, and premium vehicles to ensure a grand and elegant travel experience for the bride, groom, and guests. Whether it is wedding day travel, airport pick-ups, hotel transfers, guest transportation, or full-day car rental services, we deliver smooth, timely, and hassle-free arrangements. With professional chauffeurs, beautifully maintained vehicles, flexible packages, and 24×7 support, Pune Corporate Cars India Private Limited ensures a memorable, comfortable, and royal travel experience for your special day anywhere in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

"topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
  {
    "name": "Bridal Car Rental Pune",
    "description": "Bridal Car Rental Pune provides elegant and well-maintained cars for brides on their wedding day, ensuring a stylish, safe, and timely arrival at wedding venues with professional chauffeurs."
  },
  {
    "name": "Luxurious Wedding Cars Pune",
    "description": "Luxurious Wedding Cars Pune offers premium vehicles such as sedans, SUVs, and limousines for weddings, delivering a high-end travel experience for the bride, groom, and VIP guests."
  },
  {
    "name": "Vintage Wedding Car Pune",
    "description": "Vintage Wedding Car Pune specializes in classic and antique cars for wedding ceremonies, providing a unique and stylish transport option that adds charm and elegance to the occasion."
  },
  {
    "name": "Wedding Guest Transportation Pune",
    "description": "Wedding Guest Transportation Pune ensures smooth and organized commuting for guests attending weddings, including shuttles, multiple pickups, and professionally managed routes."
  },
  {
    "name": "Chauffeur Driven Wedding Cars Pune",
    "description": "Chauffeur Driven Wedding Cars Pune provides professional drivers for wedding cars, guaranteeing safe, punctual, and stress-free transport for brides, grooms, and guests."
  },
  {
    "name": "Groom Baraat Car Pune",
    "description": "Groom Baraat Car Pune offers specialized vehicles for the groom's procession, including decorated SUVs and luxury cars, ensuring a memorable and coordinated baraat experience."
  },
  {
    "name": "Premium Sedan Wedding Car Pune",
    "description": "Premium Sedan Wedding Car Pune provides executive sedans for weddings, ideal for family members, VIPs, or couple transfers, combining comfort, style, and professional service."
  },
  {
    "name": "SUV Wedding Car Pune",
    "description": "SUV Wedding Car Pune offers spacious and luxurious SUVs for wedding transport, suitable for group travel, family members, or VIP guests, ensuring comfort and convenience."
  },
  {
    "name": "Luxury Limousine Pune",
    "description": "Luxury Limousine Pune delivers high-end limousine services for weddings, providing a premium experience for couples and VIP guests with chauffeur-driven, well-appointed vehicles."
  },
  {
    "name": "Wedding Event Shuttle Pune",
    "description": "Wedding Event Shuttle Pune manages large-scale shuttle services for weddings, transporting multiple guests efficiently between venues, hotels, and event locations with safety and punctuality."
  },
  {
    "name": "Family Wedding Transport Pune",
    "description": "Family Wedding Transport Pune offers organized transport solutions for family members attending weddings, including sedans, SUVs, and shuttles with reliable chauffeurs."
  },
  {
    "name": "Destination Wedding Car Pune",
    "description": "Destination Wedding Car Pune provides seamless transportation for couples and guests traveling to destination weddings, ensuring comfortable, timely, and stylish arrivals."
  },
  {
    "name": "Affordable Wedding Cab Pune",
    "description": "Affordable Wedding Cab Pune offers budget-friendly wedding transportation options without compromising safety, comfort, or punctuality, suitable for small families or guests."
  },
  {
    "name": "Wedding Fleet Service Pune",
    "description": "Wedding Fleet Service Pune provides a managed fleet of wedding vehicles for large-scale events, ensuring coordinated scheduling, professional chauffeurs, and a smooth wedding transport experience."
  },
  {
    "name": "Reception Guest Cab Pune",
    "description": "Reception Guest Cab Pune offers dedicated transport services for wedding reception attendees, ensuring timely arrivals and departures with comfortable and reliable vehicles."
  }
],

"tableData": [
  ["Bridal Car Rental Pune", "Luxurious Wedding Cars Pune"],
  ["Vintage Wedding Car Pune", "Wedding Guest Transportation Pune"],
  ["Chauffeur Driven Wedding Cars Pune", "Groom Baraat Car Pune"],
  ["Premium Sedan Wedding Car Pune", "SUV Wedding Car Pune"],
  ["Luxury Limousine Pune", "Wedding Event Shuttle Pune"],
  ["Family Wedding Transport Pune", "Destination Wedding Car Pune"],
  ["Affordable Wedding Cab Pune", "Wedding Fleet Service Pune"],
  ["Reception Guest Cab Pune", ""]
],





  





"whychoose": [
  {
    "WhyChooseheading": "Wedding Car Rental Services in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers premium wedding car rental services in Pune, ensuring stylish, comfortable, and reliable transportation for the bride, groom, and wedding guests."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs for all wedding events, helping the bridal party and guests arrive on time at venues, hotels, and ceremonial locations."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable journey during wedding celebrations."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, luxury cars, SUVs, and tempo travellers—all sanitized, decorated on request, and maintained for stylish and comfortable wedding transport in Pune."
  },
  {
    "WhyChooseheading": "Customized Wedding Transport Packages",
    "WhyChoosedescription": "We offer flexible and tailored car rental plans to meet the unique transportation needs of weddings, including multiple pick-ups and coordinated travel schedules."
  },
  {
    "WhyChooseheading": "24/7 Support for Wedding Travel",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, route adjustments, and emergencies, ensuring uninterrupted transportation during wedding events."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, providing secure and hygienic rides for the wedding party and guests."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Wedding transportation is managed seamlessly through our streamlined booking process and reliable coordination, making travel for ceremonies and functions hassle-free."
  }
]





















  }

  
const faqData = [
  {
    question: 'Do you provide wedding car rental services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers elegant and reliable wedding car rental services, ensuring a luxurious and timely ride for the bride, groom, and wedding guests.',
  },
  {
    question: 'What types of vehicles are available for wedding rentals?',
    answer: 'We provide luxury sedans, SUVs, Innova Crysta, tempo travellers, and classic cars to cater to weddings of all sizes and styles.',
  },
  {
    question: 'Can multiple cars be booked for large weddings?',
    answer: 'Absolutely. We can arrange a fleet of vehicles for wedding parties, guest transfers, and pre- and post-wedding events.',
  },
  {
    question: 'How can couples or wedding planners book your services?',
    answer: 'Bookings can be made via our website, mobile app, or by contacting our 24×7 dedicated support team for personalized assistance.',
  },
  {
    question: 'Do you provide decoration and chauffeur services for wedding cars?',
    answer: 'Yes, we offer professional chauffeur services and optional car decoration to make your wedding ride memorable and elegant.',
  },
  {
    question: 'Do you offer full-day or multi-day wedding car packages?',
    answer: 'Yes, we provide flexible rental packages ranging from a few hours to multi-day wedding arrangements based on your requirements.',
  },
  {
    question: 'Are the vehicles maintained and sanitized for wedding services?',
    answer: 'All vehicles are regularly serviced, sanitized, and driven by trained, professional chauffeurs to ensure safety and comfort.',
  },
  {
    question: 'Do you offer outstation wedding car services from Pune?',
    answer: 'Absolutely. We provide outstation wedding car services for events in nearby cities and destinations, ensuring timely arrivals.',
  },
  {
    question: 'What payment options are available for wedding car rentals?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide customized invoicing for wedding planners and clients.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajeev Joshi',
    feedback: 'Excellent wedding car service in Pune. The cars were elegant, drivers professional, and the entire experience was flawless.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priyanka Sharma',
    feedback: 'Highly satisfied with the wedding car rental. Perfectly timed, luxurious rides that added charm to our wedding celebrations.',
    rating: 5,
  },
];


















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Car Rental Services in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/wedding-car-rental-pune.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers luxurious wedding car rental services in Pune for your special day. We provide bridal cars, vintage wedding cars, groom baraat cars, luxury limousines, and chauffeur-driven wedding cars. Whether it’s a destination wedding, wedding event shuttle, or family transport, our premium fleet ensures elegance and comfort for the bride, groom, and guests.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/wedding-car-rental-services-pune"
  }
};









  return (
    <div>
<Helmet>
  <title>Wedding Car Rental Services in Pune | Bridal & Luxury Wedding Cars</title>

  <meta
    name="description"
    content="Luxury wedding car rental services in Pune for bridal cars, vintage wedding cars, chauffeur-driven cars, destination weddings, wedding guest transportation, and more. Book your dream wedding car today!"
  />

  <meta
    name="keywords"
    content="Bridal Car Rental Pune, Luxurious Wedding Cars Pune, Vintage Wedding Car Pune, Wedding Guest Transportation Pune, Chauffeur Driven Wedding Cars Pune, Groom Baraat Car Pune, Premium Sedan Wedding Car Pune, SUV Wedding Car Pune, Luxury Limousine Pune, Wedding Event Shuttle Pune, Family Wedding Transport Pune, Destination Wedding Car Pune, Affordable Wedding Cab Pune, Wedding Fleet Service Pune, Reception Guest Cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/108.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingcarrentalserviceinpune;